module.exports = __webpack_public_path__ + "static/media/Success.297bedc1.png";